import Error from "./emptyType2";

export { Error };
export default Error;
